<script setup>
import { defineAsyncComponent, h } from "vue";

defineProps({
  width: { type: [Number, String], default: "100%" },
  height: { type: [Number, String], default: "100%" },
});

// The animation library and its data only download when a loading animation is first
// shown, and are prefetched once the page is idle
const StarsLottie = defineAsyncComponent(async () => {
  const [{ Vue3Lottie }, { default: stars }] = await Promise.all([
    import(
      /* webpackChunkName: "lottie", webpackPrefetch: true */ "vue3-lottie"
    ),
    import(
      /* webpackChunkName: "lottie", webpackPrefetch: true */ "@/assets/animation_stars.json"
    ),
  ]);
  return {
    props: ["width", "height"],
    setup(props) {
      return () =>
        h(Vue3Lottie, {
          animationData: stars,
          width: props.width,
          height: props.height,
          loop: true,
          speed: 2,
          autoPlay: true,
          direction: "forward",
        });
    },
  };
});
</script>

<template>
  <StarsLottie :width="width" :height="height" />
</template>
